import { getBrandDomain } from "@/app/common-utils/get-brand-domain.utils";
import { MAGNOLIA_NEXT_API_URL, QUOTE_ERROR_URL } from "@/constants";
import logError from "@/utils/logger";

const fetchQuoteError = async (errorStatusType: string) => {
  let pageJson: {
    title?: string;
    ctaPrimaryBtnLabel?: string;
    ctaSecondaryBtnLabel?: string;
    modalDescription?: string;
  } | null = {};
  try {
    const brand = getBrandDomain();
    const fetchURL = `${MAGNOLIA_NEXT_API_URL}/${QUOTE_ERROR_URL}/${brand}/${errorStatusType}`;
    const response = await fetch(fetchURL);
    if (!response.ok) {
      pageJson = {};
    }

    const res = await response.json();
    pageJson = {
      title: res.data.titleText,
      modalDescription: res.data.descriptionText,
      ctaPrimaryBtnLabel: res.data.ctaButtonOneText,
      ctaSecondaryBtnLabel: res.data.ctaButtonTwoText,
    };
  } catch (e) {
    logError(e as Error, { location: "fetchQuoteErrors.tsx" });
    pageJson = null;
  }

  return pageJson;
};

export default fetchQuoteError;
